"use client";
import { Box, Heading, SimpleGrid } from "@chakra-ui/react";
import ResourceFormModal from "./resource-form-modal";
import { ResourcePreview } from "./resource-preview";
import useResourceControl from "./use-resource-control";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { Gcms_ThemeColor } from "lib/cms-typings";
import { RichTextContent } from "@graphcms/rich-text-types";

export interface ResourcesSectionProps {
  id: string;
  title?: string;
  bg: Gcms_ThemeColor;
  /**
   * Text color for the resource section
   */
  color: Gcms_ThemeColor;
  /**
   * Description text for the resource
   */
  content?: {
    raw: RichTextContent;
  };
  resources: Array<{
    id: string;
    slug?: string;
    title?: string;
    subtitle?: string;
    /**
     * The preview image for the resource
     */
    thumbnail?: {
      id: string;
      url: string;
      width?: number;
      height?: number;
      handle: string;
    } | null;
  }>;
  /**
   * Text displayed with checkbox for users to sign up for AreaHub's newsletters
   */
  newsletterText?: string;
}

export const ResourcesSection = (props: ResourcesSectionProps) => {
  const { disclosure, onOpenResource, slug } = useResourceControl();
  return (
    <Box as="section" pt="4rem">
      <Box
        maxW={{ base: "xl", md: "5xl" }}
        mx="auto"
        px={{ base: "6", md: "8" }}
        mb={5}
      >
        <Box textAlign="center">
          <Heading
            as="h1"
            size="4xl"
            fontWeight="extrabold"
            maxW="48rem"
            mx="auto"
            lineHeight="1.2"
            letterSpacing="tight"
            mb={3}
          >
            {props.title}
          </Heading>
          <RichText content={props?.content?.raw as RichTextContent} />
        </Box>
      </Box>
      <Box bg={props.bg} color={props?.color}>
        <Box maxW={{ base: "xl", md: "7xl" }} mx="auto">
          <SimpleGrid
            columns={{ base: 1, md: 2, lg: 3 }}
            alignItems="start"
            justifyItems="center"
            spacing={{ base: "12", lg: "16" }}
            color={props.color}
          >
            {props?.resources?.map((resource) => (
              <ResourcePreview
                key={resource.id}
                {...resource}
                onClick={() => onOpenResource(resource?.slug as string)}
              />
            ))}
          </SimpleGrid>
        </Box>
      </Box>
      <ResourceFormModal
        disclosure={disclosure}
        slug={slug}
        newsletterText={props.newsletterText}
      />
    </Box>
  );
};
